import React, { useState, useEffect } from "react";
import Gantt from "./components/gantt";
import Popup from "../../components/Popup";
import { Box, FormControlLabel, Switch, Grid, Stack, FormControl, RadioGroup, Radio, Select, MenuItem, IconButton, InputLabel, Tooltip } from "@mui/material";
//import { useGetGanttData } from "../../api/gantt";
import { FormattedMessage, useIntl } from "react-intl";

import ProductionPlanInfoDialog from "./components/productionPlanInfoDialog";
import PlanNewPODialog from "./components/planNewPODialog";
import PlanUpdatePODialog from "./components/planUpdatePODialog";
import AxionControls from "../../components/controls/AxionControls";
//import ProductionPlanList from "./components/productionPlanList";
import ProductionPlanMachineList from "./components/productionPlanMachineList";
import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { fetchMachines } from "../../fetchers/machine";
import { updatePO, cancelAllChanges, cancelChangesForMachine, saveAllChangesForMachines } from "../../fetchers/productionPlan";
import { getAllProductionOrderOee } from "../../fetchers/productionOrder";
import { ReplanMachine2, ReCalculateEndTime, GetSuggestedPlanningForMachine, ReCalculateEndTimeForNewOrder, placeWithShiftsAndBlockers, buildShiftsForMachine, buildBlockers } from "./components/planningFunctions";
import { pushErrorMessage, pushNotification } from "../../utils/notifications";
import dayjs from "dayjs";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import messages from "./messages";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../assets/theme";
import { fetchCompany } from "../../fetchers/company";
import useFeatureFlags, { isFeatureEnabled } from "../../hooks/useFeatureFlags";
import AlarmBanner from './components/alarmBanner';
import { fetchAreas } from "../../fetchers/area";
import { fetchMachineTypes } from "../../fetchers/machineType";
import { fetchProductionPlan, getOeeDataCurrentPO } from "../../fetchers/productionPlan";
import { getShiftByShift } from "../../fetchers/productionCalendar";

//Icons
import ListIcon from '@mui/icons-material/List';
import ViewCompactOutlinedIcon from '@mui/icons-material/ViewCompactOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';

export default function ProductionPlan() {

    const gapInMinutes = 120;
    const defaultOee = 0.8;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
    const navigate = useNavigate();

    const { formatMessage } = useIntl();
    //const { data, isLoading, isFetching, isSuccess, refetch } = useGetGanttData(companyKey);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [openAddPopup, setOpenAddPopup] = React.useState(false);
    const [openUpdatePopup, setOpenUpdatePopup] = React.useState(false);
    const [showList, setShowList] = React.useState(false);
    const [editMachine, setEditMachine] = React.useState({});
    const [addObjAtTime, setAddObjAtTime] = React.useState(null);
    const [machineStop, setMachineStop] = React.useState(null);
    const [showBackdrop, setShowBackdrop] = React.useState(false);
    const [filteredStopReasonCodes, setFilteredStopReasonCodes] = React.useState([]);
    //const [filteredGanttData, setFilteredGanttData] = React.useState();
    const [statusFilter, setStatusFilter] = useState("");
    const [machineFilter, setMachineFilter] = useLocalStorage("ProdPlanMachineFilter", []);
    const [areaFilter, setAreaFilter] = useLocalStorage("ProdPlanAreaFilter", []);
    const [runningFilter, setRunningFilter] = useLocalStorage("ProdPlanRunningFilter", false);
    const [calculatedEndFilter, setCalculatedEndFilter] = useLocalStorage("ProdPlanCalculatedEndFilter", "false");
    const [showReplanned, setShowReplanned] = useLocalStorage("ProdPlanShowReplanned", false);
    const [showCalendar, setShowCalendar] = useLocalStorage("ProdPlanShowCalendar", false);
    const [showMain, setShowMain] = useLocalStorage("ProdPlanShowMain", true);
    const [showUnsaved, setShowUnsaved] = useLocalStorage("ProdPlanShowUnsaved", false);
    const [capacityFilter, setCapacityFilter] = useState("");
    const [machinetypeFilter, setMachinetypeFilter] = useState("");
    const [timeSpan, setTimeSpan] = useLocalStorage("ProdPlanTimespan", "week");
    const [startDatex, setStartDatex] = useLocalStorage("ProdPlanStartDate", dayjs());
    const [endDatex, setEndDatex] = useLocalStorage("ProdPlanEndDate", dayjs());
    const [period, setPeriod] = React.useState({});
    const [plannedData, setPlannedData] = useState([]);
    const [selectedValue, setSelectedValue] = React.useState(timeSpan);
    const [groupBy, setGroupBy] = useLocalStorage("ProdPlanGroupBy", "");
    const [checked, setCheck] = useLocalStorage("checked", {
        running: false,
        onlyPlanned: false,
        onlyStopped: false,
    });
    const [unfilteredData, setUnfilteredData] = useState([]);
    const [snapToPrevious, setSnapToPrevious] = useLocalStorage("PplSnapToPrevious", "true");
    const [replanOverlaps, setReplanOverlaps] = useLocalStorage("PplReplanOverlaps", "true");
    const [recalculateAffectedOrders, setRecalculateAffectedOrders] = useLocalStorage("PplRecalculateAffectedOrders", "false");
    const [showBlockValue, setShowBlockValue] = useLocalStorage("PplShowBlockValues", "PO"); //PO, Tool, Item
    const [edit, setEdit] = useLocalStorage("PplEdit", "false");
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const [disableSaveRowsButton, setDisableSaveRowsButton] = useState(false);
    const [markedForUpdate, setMarkedForUpdate] = useState([]);
    const [changelog, setChangelog] = useState([]); //{ProductionOrderId: 123, OldStart: "", OldEnd: "", NewStart: "", NewEnd: "", TimeStamp: }
    const [zoomLevel, setZoomLevel] = useLocalStorage("PPLganttZoomLevel", 4);
    const [zoomToDates, setZoomToDates] = useState({ min: null, max: null });
    const isoFormat = "YYYY-MM-DDTHH:mm:ss";

    //const [shifts, setShifts] = useState([]);
    const [machineBlockers, setMachineBlockers] = useState([]);
    const [machineShifts, setMachineShifts] = useState([]);


    let startDate = null;
    let endDate = null;

    let machineFilterLocal = machineFilter;
    let areaFilterLocal = areaFilter;
    let runningFilterLocal = runningFilter;
    let calculatedEndFilterLocal = calculatedEndFilter.toString() === "true" ? true : false;
    let showReplannedLocal = showReplanned;
    let showMainLocal = showMain;
    let showUnsavedLocal = showUnsaved;
    let groupByLocal = groupBy;
    let showCalendarLocal = showCalendar;
    let editLocal = edit;

    //Initial load dates for production plan
    startDate = dayjs(new Date()).add(-3, 'month').format(isoFormat);
    endDate = dayjs(new Date()).add(3, 'month').format(isoFormat);

    let startDateDate = dayjs(startDate).format("YYYY-MM-DD");
    let endDateDate = dayjs(endDate).format("YYYY-MM-DD");

    useEffect(() => {
        setStartDatex(startDate);
        setEndDatex(endDate);
    }, []);

    const featuresQuery = useFeatureFlags();

    const companyQuery = useQuery(
        ["company", companyKey],
        () => fetchCompany(companyKey),
        {
            // refetchInterval: 300000,
            // staleTime: 60000
        }
    );

    const areaQuery = useQuery(
        ["areas"],
        () => fetchAreas(),
        {}
    );
    const machineQuery = useQuery(
        ["machines", companyKey],
        () => fetchMachines(companyKey),
        {}
    );
    const machineTypesQuery = useQuery(
        ["machineTypes", companyKey],
        () => fetchMachineTypes(companyKey),
        {}
    );
    const scheduleRowsQuery = useQuery(
        ["scheduleRows", companyKey, startDateDate, endDateDate],
        () => getShiftByShift(companyKey, startDateDate, endDateDate, null),
        {}
    );
    const prodPlanQuery = useQuery(
        ["prodPlans", companyKey],
        () => fetchProductionPlan(companyKey, startDate, endDate),
        {}
    );
    const OeeDataQuery = useQuery(
        ["OeeData", companyKey],
        () => getOeeDataCurrentPO(companyKey, dayjs().add(-4, 'hour').format(isoFormat)),
        {}
    );
    const OeeDataQuery100Days = useQuery(
        ["OeeDataQuery100Days", companyKey],
        () => getOeeDataCurrentPO(companyKey, dayjs().add(-100, 'day').format(isoFormat)),
        {}
    );
    const historicOeeDataQuery = useQuery(
        ["HistoricOeeData", companyKey],
        () => getAllProductionOrderOee(companyKey),
        {}
    );

    // Build shifts for each machine based on schedule rows and machine data
    useEffect(() => {
        var localMachineShifts = [];

        if (!scheduleRowsQuery.data || !machineQuery.data) {
            //console.log("Schedule rows or machine data not loaded yet for building shifts. scheduleRowsQuery.data:", scheduleRowsQuery.data, "machineQuery.data:", machineQuery.data);

        } else {
            //console.log ("Building machine shifts. scheduleRowsQuery.data:", scheduleRowsQuery.data, "machineQuery.data:", machineQuery.data);
            machineQuery.data?.forEach((machine) => {
                let builtShifts = buildShiftsForMachine(scheduleRowsQuery.data?.data, machine.id);
                localMachineShifts.push({ machineId: machine.id, shifts: builtShifts });
            });
            setMachineShifts(localMachineShifts);
            //console.log("Machine shifts built and set for machines:", localMachineShifts);
        }
    }, [scheduleRowsQuery.data, machineQuery.data]);

    //Build blockers based on existing production plans
    useEffect(() => {
        let loclalBlockers = [];

        if (!prodPlanQuery.data || !machineQuery.data) {
            //console.log("Production plan data not loaded yet for building blockers. prodPlanQuery.data:", prodPlanQuery.data, "machineQuery.data:", machineQuery.data);
        } else {
            //console.log("Building blockers for machines based on production plan data:", prodPlanQuery.data);
            machineQuery.data?.forEach((machine) => {

                let plansForMachine = prodPlanQuery.data.find(plan => plan.machineId === machine.id)?.productionPlans || [];
                //console.log ("Building blockers for machine:", machine.machineName, "plansForMachine:", plansForMachine);

                plansForMachine.forEach(plan => {
                    if (plan.rowType === 2) {
                        plan.plannedOrReplannedStartTime = plan.plannedStartTime;
                        plan.plannedOrReplannedEndTime = plan.plannedEndTime;
                    }
                });

                let builtBlockers = buildBlockers(plansForMachine);
                //console.log("Built blockers for machine:", machine.machineName, "blockers:", builtBlockers);
                loclalBlockers.push({ machineId: machine.id, machineName: machine.machineName, blockers: builtBlockers });
            });
            setMachineBlockers(loclalBlockers);
            //console.log("Blockers built and set for machines:", loclalBlockers);
        }
    }, [prodPlanQuery.data, machineQuery.data]);

    const controlProps = (item) => ({
        checked: selectedValue === item,
        onChange: handleChange,
        value: item,
        name: "size-radio-button-demo",
        inputProps: { "aria-label": item },
    });

    //Change handle for radio buttons when selecting new timespan for api fetch.
    const handleChange = (event) => {

        if (event.target.value === "week") {
            //getWeekData();
            zoomTo("week");
        } else if (event.target.value === "month") {
            //getMonthData();
            zoomTo("month");
        } else if (event.target.value === "ThreeMonths") {
            //getThreeMonthsData();
            zoomTo("ThreeMonths");
        }

        setSelectedValue(event.target.value);
        setTimeSpan(event.target.value);
    };

    useEffect(() => {
        //console.log("prodPlanQuery.data updated!!");
        handleData();
    }, [prodPlanQuery.data, OeeDataQuery.data]);


    function getMachineNameById(id) {
        const machine = machineQuery.data?.find((machine) => machine.id === id);
        return machine ? machine.machineName : "";
    }

    const handleRefreshData = () => {
        prodPlanQuery.refetch();
    };

    const handleUpdatePO = (period) => {

        setShowBackdrop(true);

        const productionOrderId = period.productionOrderId;
        const startTime = period.start;
        const endTimeBlocker = period.end;
        const machineId = period.machineId;
        // const endTime = period.end;
        // const productId = period.itemNo;
        // const quantity = period.plannedQty;
        // const idealCycleTime = period.idealCycleTime;
        // const productionOrderId = period.productionOrderId;

        const logDate = dayjs().format(isoFormat);

        let machineData = plannedData[0]?.children?.filter(machine => machine.id === period?.machineId)

        //console.log("!!handleUpdatePO called for period:", {...period}, "machineData:", machineData, "period.machineId:", period?.machineId);
        let machineName = getMachineNameById(machineId);


        //Recalculate end time for moved order
        //let calculatedEndTime = ReCalculateEndTimeForNewOrder(period, machineData, defaultOee, idealCycleTime, companyKey, OeeDataQuery.data);
        console.log("Oee Value for Drag and Drop Update:", period?.oeeValue, defaultOee, period);

        let calculatedEndTime = ReCalculateEndTimeForNewOrder(period.start, period.plannedQty, period.reportedQty, period?.oeeValue || defaultOee, period.speedUnitTypeId, period.idealCycleTime);
        //calculated end time based on ideal speed remaing qty and OEE
        //let calculatedEndTime = ReCalculateEndTime(period, item.speedUnitTypeId, currentOEE);
        let localCalcEndTime = calculatedEndTime.calcEndTime;
        let localIdealTimeToEnd = calculatedEndTime.idealTimeToEnd;
        let localIdealRunTime = calculatedEndTime.idealRunTime;

        //console.log ("Calculated new end time for moved order:", localCalcEndTime, "idealTimeToEnd:", localIdealTimeToEnd, "idealRunTime:", localIdealRunTime);

        //If Blocker, dont use calculated end time
        if (period.rowType === 2) {
            localCalcEndTime = dayjs(endTimeBlocker).format(isoFormat);
        }

        let updPO = {
            ...period,
            "companyId": companyKey,
            "start": dayjs(startTime).format(isoFormat),
            "end": dayjs(localCalcEndTime).format(isoFormat),
            // "plannedStartTime": formatDateAndFullTime(period.plannedStartTime),
            // "plannedEndTime": formatDateAndFullTime(period.plannedEndTime),
            "replannedStartTime": dayjs(startTime).format(isoFormat),
            "replannedEndTime": dayjs(localCalcEndTime).format(isoFormat),
            "plannedOrReplannedStartTime": dayjs(startTime).format(isoFormat),
            "plannedOrReplannedEndTime": dayjs(localCalcEndTime).format(isoFormat),
        }

        // console.log("Calling ReplanMachine2", "snapToPrevious:", snapToPrevious, "replanOverlaps:", replanOverlaps, "recalculateAffectedOrders:", recalculateAffectedOrders);
        // console.log("period before replanning:", {...updPO});
        let replannedData = ReplanMachine2(updPO, machineData, machineName, gapInMinutes, snapToPrevious, replanOverlaps, recalculateAffectedOrders, companyKey, scheduleRowsQuery.data, historicOeeDataQuery.data, defaultOee); //    return {replannedOrder: updatePOData, replannedOrders: periods};

        //console.log("!!Replanned data from function:", replannedData);

        replannedData.replannedOrders.forEach((period) => {

            //console.log("!!Update PO:", period);

            period.edit = edit.toString() === "true" ? true : false;

            updatePO(period).then((result) => {

                //console.log("!! PO updated in update:", result?.data?.manufacturingOrder?.moNo, result);

                //setShowBackdrop(false);

                if (result.status) {
                    addToChangelog(period.productionOrderId, period.plannedStartTime, period.plannedEndTime, period.replannedStartTime, period.replannedEndTime, logDate);
                    if (edit !== "true") {
                        pushNotification("Production plan updated: " + result?.data?.manufacturingOrder?.moNo || period.productionOrderId);
                    }
                } else {
                    pushErrorMessage("Could not update plan: " + result?.message);
                }

            }).catch((error) => {
                //console.log("Could not update plan in erp system", error);
                pushErrorMessage("Could not update plan in erp system", error);
            });
        });

        //console.log("Update moved PO:", replannedData.replannedOrder);
        replannedData.replannedOrder.edit = edit.toString() === "true" ? true : false;



        updatePO(replannedData.replannedOrder).then((result) => {

            //console.log("Moved PO updated:", result?.data?.manufacturingOrder?.moNo || productionOrderId, result);

            setShowBackdrop(false);

            if (result.status) {
                addToChangelog(replannedData.replannedOrder.productionOrderId, replannedData.replannedOrder.plannedStartTime, replannedData.replannedOrder.plannedEndTime, replannedData.replannedOrder.replannedStartTime, period.replannedEndTime, logDate);
                if (edit !== "true") {
                    pushNotification("Moved Production plan updated: " + result?.data?.manufacturingOrder?.moNo || productionOrderId);
                }
            } else {
                pushErrorMessage("Could not move plan: " + result?.message);
            }
            //Reload data after all updates are done
            prodPlanQuery.refetch();

            //console.log("Changelog:", changelog);


        }).catch((error) => {
            console.log("Could not update order", error);
            pushErrorMessage("Could not update order:   " + error);
            setShowBackdrop(false);
            //Reload data after all updates are done
            prodPlanQuery.refetch();
        });
    }

    function addToChangelog(machineId, productionOrderId, oldStart, oldEnd, newStart, newEnd, timeStamp) {
        //console.log("addToChangelog called", machineId, productionOrderId, oldStart, oldEnd, newStart, newEnd, timeStamp);
        let localChangelog = changelog;
        const logEntry = {
            MachineId: machineId,
            ProductionOrderId: productionOrderId,
            OldStart: oldStart,
            OldEnd: oldEnd,
            NewStart: newStart,
            NewEnd: newEnd,
            TimeStamp: timeStamp
        };
        //console.log("Adding to changelog:", logEntry);
        localChangelog.push(logEntry);
        setChangelog([...localChangelog]);
    }

    function removeFromChangelogForMachine(machineId) {
        // Remove all entries for a machine to clear all changes for that machine
        let localChangelog = changelog;
        localChangelog = localChangelog.filter(entry => entry.MachineId !== machineId);
        setChangelog([...localChangelog]);
    }

    function getLatestChangelogEntrys() {
        let orderedChangelog = changelog.sort((a, b) => dayjs(b.TimeStamp).isAfter(dayjs(a.TimeStamp)) ? 1 : -1)[0]?.TimeStamp;
        let latestEntrys = changelog.filter(entry => entry.TimeStamp === orderedChangelog);

        return latestEntrys;
    }

    function removeLatestChangelogEntrys() {
        let orderedChangelog = changelog.sort((a, b) => dayjs(b.TimeStamp).isAfter(dayjs(a.TimeStamp)) ? 1 : -1)[0]?.TimeStamp;
        setChangelog(changelog.filter(entry => entry.TimeStamp !== orderedChangelog));
        return;
    }

    function getStartOfWeek() {
        //get startdatetime formonday of current week
        let startOfWeek = dayjs(new Date()).startOf('week').toDate();
        startOfWeek = dayjs(startOfWeek).add(-5, 'day');
        startOfWeek = startOfWeek.format(isoFormat);
        return startOfWeek;
    }
    function getEndOfWeek() {
        //get enddatetime to sunday of current week
        let endOfWeek = dayjs(new Date()).endOf('week').toDate();
        endOfWeek = dayjs(endOfWeek).add(5, 'day');
        endOfWeek = endOfWeek.format(isoFormat);
        return endOfWeek;
    }
    function getStartOfMonth() {
        //get startdatetime formonday of current week
        let startOfMonth = dayjs(new Date()).startOf('month').toDate();
        startOfMonth = dayjs(startOfMonth).add(-20, 'day');
        startOfMonth = startOfMonth.format(isoFormat);
        return startOfMonth;
    }
    function getEndOfMonth() {
        //get enddatetime to sunday of current week
        let endOfMonth = dayjs(new Date()).endOf('month').toDate();
        endOfMonth = dayjs(endOfMonth).add(20, 'day');
        endOfMonth = endOfMonth.format(isoFormat);
        return endOfMonth;
    }
    function getStartOfThreeMonths() {
        //get startdatetime formonday of current week
        let startPrevMonth = dayjs(new Date()).startOf('month').toDate();
        startPrevMonth = dayjs(startPrevMonth).add(-2, 'month');
        startPrevMonth = startPrevMonth.format(isoFormat);
        return startPrevMonth;
    }
    function getEndOfThreeMonths() {
        //get enddatetime to sunday of current week
        let endOfUpcommingMonth = dayjs(new Date()).endOf('month').toDate();
        endOfUpcommingMonth = dayjs(endOfUpcommingMonth).add(2, 'month');
        endOfUpcommingMonth = endOfUpcommingMonth.format(isoFormat);
        return endOfUpcommingMonth;
    }

    function getAreaNameById(id) {
        const area = areaQuery?.data?.find(area => area.areaKey === id);
        return area.areaName || "???";
    }

    const zoomTo = (span) => {
        switch (span) {
            case "week":
                startDate = dayjs(new Date()).startOf('week').toDate();
                endDate = dayjs(new Date()).endOf('week').toDate();
                if (dayjs(startDate).day() < 3) {
                    startDate = dayjs(startDate).add(-2, 'day').toDate();
                }
                if (dayjs(endDate).day() > 5) {
                    endDate = dayjs(endDate).add(2, 'day').toDate();
                }

                break;
            case "month":
                startDate = dayjs(new Date()).startOf('month').toDate();
                endDate = dayjs(new Date()).endOf('month').toDate();
                if (dayjs(startDate).day() < 10) {
                    startDate = dayjs(startDate).add(-5, 'day').toDate();
                }
                if (dayjs(endDate).day() > 20) {
                    endDate = dayjs(endDate).add(5, 'day').toDate();
                }
                break;
            case "ThreeMonths":
                startDate = dayjs(new Date()).startOf('month').add(-1, 'month').toDate();
                endDate = dayjs(new Date()).startOf('month').add(2, 'month').toDate();
                break;
            default:
                startDate = startDatex;
                endDate = endDatex;
                break;
        }

        startDate = dayjs(startDate).format(isoFormat);
        endDate = dayjs(endDate).format(isoFormat);
        //return { start: startDate, end: endDate };
        setZoomToDates({ min: startDate, max: endDate });
    }

    function getOrderFirstTimeStamp(orderId) {
        let runningOrder = OeeDataQuery100Days.data?.find(order => order.activeProductionOrder === orderId && order.machineId === period.machineId);
        return runningOrder?.startDate || null;
    }

    function getOeeForRunningOrder(orderId) {
        let runningOrder = OeeDataQuery.data?.find(order => order.activeProductionOrder === orderId);
        return runningOrder?.tak / 100 || defaultOee;
    }

    //Check if this Feature is enabled
    if (featuresQuery === undefined || featuresQuery.data === undefined || featuresQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }

    if (!isFeatureEnabled(featuresQuery, "ProductionPlanning")) {
        return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <h2><FormattedMessage {...messages.comingSoon} /></h2>
        </Box>
    }


    if (featuresQuery === undefined || featuresQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (scheduleRowsQuery === undefined || scheduleRowsQuery.data === undefined || scheduleRowsQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (companyQuery === undefined || companyQuery.data === undefined || companyQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (areaQuery === undefined || areaQuery.data === undefined || areaQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (machineQuery === undefined || machineQuery.data === undefined || machineQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (machineTypesQuery === undefined || machineTypesQuery.data === undefined || machineTypesQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (prodPlanQuery === undefined || prodPlanQuery.data === undefined || prodPlanQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (OeeDataQuery === undefined || OeeDataQuery.data === undefined || OeeDataQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (OeeDataQuery100Days === undefined || OeeDataQuery100Days.data === undefined || OeeDataQuery100Days.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }
    if (historicOeeDataQuery === undefined || historicOeeDataQuery.data === undefined || historicOeeDataQuery.isLoading) {
        return <AxionControls.AxionBackdrop open={true} />
    }

    if (!prodPlanQuery.isRefetching && showBackdrop === true) {
        setShowBackdrop(false);
    }


    // Show the PO/Operation(period) when clicking on a period
    const handleClick = (period) => {
        console.log("handleClick called width edit:", edit, edit.toString() === "true", " period.erpStatus:", period.erpStatus);
        setShowBackdrop(true);
        setPeriod(period);
        setEditMachine(period.machineId);
        //console.log("erpstatus:", period.erpStatus);

        if (edit.toString() === "true") {
            if (period.erpStatus === null || period.erpStatus.toString() === "0" || period.erpStatus.toString() === "1" || period.erpStatus.toString() === "2" || isActivePO(period.productionOrderId, period.activePO)) {
                setOpenUpdatePopup(true);
            } else {
                setOpenPopup(true);
            }
        } else {
            setOpenPopup(true);
        }
        setShowBackdrop(false);
    };

    const handleClickRow = (row) => {
        if (row.id.toString().substring(0, 4) === "9999") {
            return
        }

        let machine = plannedData[0]?.children?.find(m => m.id === row.machineId);
        let period = machine?.periods?.find(p => p?.productionOrderId === row.productionOrderId && p?.machineId === row.machineId);

        handleClick(period);
    };


    const handleOpenNewPO = (machine, addObjAtTime) => {
        //console.log("erpstatus:", period.erpStatus);
        setEditMachine(machine);
        setAddObjAtTime(addObjAtTime);

        //alert("handleOpenNewPO");
        setShowBackdrop(true);
        //setNewPOData(machine);
        setOpenAddPopup(true);
        setShowBackdrop(false);
    };

    const handleOpenUpdatePO = (machineId, period) => {
        console.log("handleOpenUpdatePO called with machineId:", machineId, "period:", period);
        // is this used???  check out handleClick instead...
        //console.log("erpstatus:", period.erpStatus);
        //  const handleOpenNewPO = (machine) => {
        setEditMachine(machineId);
        setPeriod(period);

        if (period.erpStatus === 1 || period.erpStatus === 2) {
            setOpenPopup(false);
            setShowBackdrop(true);
            setOpenUpdatePopup(true);
            setShowBackdrop(false);
        } else {
            handleClick(period);
        }
    };

    const handleShowList = () => {
        setShowList(!showList);
    }

    const handleCancelSaveAll = () => {
        setShowBackdrop(true);

        //get all machines currently shown based on machinefilter and area filter

        //console.log ("handleCancelSaveAll called. plannedData:", plannedData);

        let machinesToCancel = plannedData[0]?.children?.filter(machine => machine.rowType === "main").map(machine => machine.id) || [];

        //console.log("Machines to cancel for handleCancelSaveAll:", machinesToCancel);

        cancelChangesForMachine(companyKey, machinesToCancel).then(() => {
            //cancelAllChanges(companyKey).then(() => {
            pushNotification("All changes reverted");
            prodPlanQuery.refetch();
            setShowBackdrop(false);
            prodPlanQuery.refetch();
        }).catch((error) => {
            console.log("Could not cancel changes", error);
            pushErrorMessage("Could not cancel changes: " + error);
            setShowBackdrop(false);
            prodPlanQuery.refetch();
        });
    }

    const handleSaveAll = () => {
        setShowBackdrop(true);
        setDisableSaveButton(true);

        //get all machines currently shown based on machinefilter and area filter
        let machinesToSave = plannedData[0]?.children?.filter(machine => machine.rowType === "main").map(machine => machine.id) || [];

        // saveAllChanges(companyKey).then((result) => {
        saveAllChangesForMachines(companyKey, machinesToSave).then((result) => {
            if (result.status === false) {
                pushErrorMessage("Not all changes could be saved. An error occurred: " + result?.message);
            } else {
                pushNotification("All changes saved. " + result?.message);
            }
            setDisableSaveButton(false);
            setShowBackdrop(false);
            prodPlanQuery.refetch();

        }).catch((error) => {
            console.log("Could not save changes", error);
            pushErrorMessage("Could not save changes: " + error);
            setDisableSaveButton(false);
            setShowBackdrop(false);
            prodPlanQuery.refetch();
        });
    }

    const handleSaveAllForMachine = (machineId) => {
        setShowBackdrop(true);
        setDisableSaveButton(true);

        saveAllChangesForMachines(companyKey, [machineId]).then((result) => {
            if (result.status === false) {
                pushErrorMessage("Not all changes could be saved for machine " + machineId + ". An error occurred: " + result?.message);
            } else {
                pushNotification("All changes saved for machine " + machineId + ". " + result?.message);
            }
            setDisableSaveButton(false);
            setShowBackdrop(false);
            prodPlanQuery.refetch();

        }).catch((error) => {
            console.log("Could not save changes for machine " + machineId, error);
            pushErrorMessage("Could not save changes for machine " + machineId + ": " + error);
            setDisableSaveButton(false);
            setShowBackdrop(false);
            prodPlanQuery.refetch();
        });
    }

    function toggleValue(arr, value) {
        const index = arr.indexOf(value);
        if (index === -1) {
            // Value does not exist → add it
            arr.push(value);
        } else {
            // Value exists → remove it
            arr.splice(index, 1);
        }
        return arr; // optional
    }

    let localMarkedForUpdate = markedForUpdate;
    const handleCheckboxClick = (machineId, checked) => {
        let v = localMarkedForUpdate;
        localMarkedForUpdate = toggleValue(v, machineId);
        setMarkedForUpdate(localMarkedForUpdate);
    }

    const handleRowSaveClick = (machineId) => {
        //console.log("Row save clicked:", machineId);
        handleSaveAllForMachine(machineId);
    }

    const handleRowUndoClick = (machineId) => {
        //console.log("Row undo clicked:", machineId);
        cancelChangesForMachine(companyKey, [machineId]).then((result) => {

            //console.log("Row undo :", machineId, result);

            //setShowBackdrop(false);

            if (result.status) {
                pushNotification("Row undone: " + machineId);
            } else {
                pushErrorMessage("Could not undo row: " + result?.message);
            }

            prodPlanQuery.refetch();

        }).catch((error) => {
            //console.log("Could not update plan in erp system", error);
            pushErrorMessage("Could not undo row", error);
        });
    };

    const handleSetShowBlockValue = (value) => {
        setShowBlockValue(value);
        handleData();
    }

    const handleSetEdit = (value) => {
        setEdit(value);
        editLocal = value;
        if (value.toString() === "true") {
            calculatedEndFilterLocal = false;
            setCalculatedEndFilter(false);
        }
        handleData();
    }

    const handleSaveMarkedRows = async () => {
        //setShowBackdrop(true);
        //setDisableSaveButton(true);

        //get all raplanned data for a row/machine

        // let mId = 13; //M47

        //console.log("handleSaveMarkedRows markedForUpdate:", markedForUpdate, localMarkedForUpdate);

        let resultStatus = true;
        let count = 0;
        let countPeriods = 0;

        const updatePromises = [];

        markedForUpdate.forEach(mId => {
            let machineRow = plannedData[0]?.children?.find(row => row.id.toString() === mId && row.name.includes("(rep)"));

            if (!machineRow?.periods) {
                return;
            }

            let periodsToUpdate = machineRow.periods.filter(row => (row.erpStatus === "0" || row.erpStatus === "1" || row.erpStatus === "2")); // && row.productionOrderId !== row.activePO

            countPeriods = countPeriods + periodsToUpdate.length;

            periodsToUpdate.forEach(period => {
                let upd = {
                    ...period,
                    start: dayjs(period.start).format(isoFormat),
                    end: dayjs(period.end).format(isoFormat),
                    replannedStartTime: dayjs(period.start).format(isoFormat),
                    replannedEndTime: dayjs(period.end).format(isoFormat),
                    edit: edit.toString() === "true" ? true : false,
                    companyId: companyKey,
                };

                updatePromises.push(
                    updatePO(upd)
                        .then((result) => {
                            if (result.status) {
                                count++;
                                if (edit.toString() !== "true") {
                                    pushNotification("Production plan updated: " + (result?.data?.manufacturingOrder?.moNo || upd.productionOrderId));
                                }
                            } else {
                                resultStatus = false;
                                pushErrorMessage("Could not update plan: " + result?.message);
                            }
                        })
                        .catch((error) => {
                            resultStatus = false;
                            pushErrorMessage("Could not update plan: " + error?.message);
                        })
                );
            });
        });

        await Promise.allSettled(updatePromises);

        if (resultStatus) {
            pushNotification("All " + countPeriods + " marked rows were updated");
        } else {
            pushNotification(count + " rows of " + countPeriods + " updated.");
        }
        prodPlanQuery.refetch();
        // ));


    }

    function isNumeric(value) {
        return !isNaN(value) && !isNaN(parseFloat(value));
    }

    function formatDate(date) {
        return date ? new Date(date).toLocaleDateString('sv-SE') : "";
    }

    function formatFullTime(date) {
        return date ? new Date(date).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : "";
    }

    function formatTime(date) {
        return date ? new Date(date).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' }) : "";
    }

    function formatDateAndTime(date) {
        return date ? formatDate(date) + " " + formatTime(date) : "";
    }

    function formatDateAndFullTime(date) {
        return date ? formatDate(date) + "T" + formatFullTime(date) : "";
    }
    function xformatDateTimeInIsoFormat(date) {
        if (date === undefined || date === null) return "";
        let d = new Date(date).toLocaleDateString('sv-SE');
        let t = new Date(date).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        return date ? d + "T" + t + "Z" : "";
    }

    const handleUpdateData = (id, data) => {

        console.log("handleUpdateData called with id:", id, "data:", data);

        let shouldUpdate = false;

        let upd = data.find((plan) => plan.periodId === id);

        // Fix to wait for end date event to fire after start date event
        if (isNumeric(upd.end.toString())) {
            shouldUpdate = true;
        } else {
            return;
        }

        upd = {
            ...upd,
            start: dayjs(upd.start).format(isoFormat),
            end: dayjs(upd.end).format(isoFormat),
        };
        console.log("Moved", upd.start, upd.end);

        if (shouldUpdate) {
            //console.log("handleUpdateData", id, newData);
            //updateProductionPlans(id, newData);
            handleUpdatePO(upd);
        }

    }

    // const handleRefresh = () => {
    //     refetch();
    // }

    const handleSplit = (id) => {
        navigate(`/machinestops/${id}/split`);
    }

    const handleTimeSpan = (ts) => {
        // Update state or perform any other action with childData
        setTimeSpan(ts);
    };

    const handleCheck = (event) => {
        if (event.target.name === "running") {
            if (!checked.running) {
                setCheck({
                    ...checked,
                    running: true,
                    onlyPlanned: false,
                    onlyStopped: false,
                });
            }
            if (checked.running) {
                setCheck({
                    ...checked,
                    running: false,
                    onlyPlanned: false
                });
            }
        }
        if (event.target.name === "onlyPlanned") {
            if (!checked.onlyPlanned) {
                if (!checked.onlyStopped) {
                    setCheck({
                        ...checked,
                        running: false,
                        onlyPlanned: true,
                        onlyStopped: false,
                    });
                } else {
                    setCheck({
                        ...checked,
                        running: false,
                        onlyPlanned: true,
                        onlyStopped: true,
                    });
                }
            }
            if (checked.onlyPlanned) {
                setCheck({
                    ...checked,
                    onlyPlanned: false
                });
            }
        }
        if (event.target.name === "onlyStopped") {
            if (!checked.onlyStopped) {
                if (!checked.onlyPlanned) {
                    setCheck({
                        ...checked,
                        running: false,
                        onlyPlanned: false,
                        onlyStopped: true,
                    });
                } else {
                    setCheck({
                        ...checked,
                        running: false,
                        onlyPlanned: true,
                        onlyStopped: true,
                    });
                }
            }
            if (checked.onlyStopped) {
                setCheck({
                    ...checked,
                    onlyStopped: false,
                });
            }
        };
    };

    const handleMachinesFilter = (event, newValue) => {
        setMachineFilter(newValue);
        machineFilterLocal = newValue;
        handleData();
    }

    const handleAreaFilter = (event, newValue) => {
        setAreaFilter(newValue)
        areaFilterLocal = newValue;
        handleData();
    }

    const handleRunningFilter = (event, newValue) => {

        //console.log("handleRunningFilter event", event.target.checked);
        var value = runningFilter;
        value = value === true ? false : true;
        setRunningFilter(value);
        runningFilterLocal = value === true;

        // setRunningFilter(event.target.checked);
        // runningFilterLocal = event.target.checked;

        console.log("handleRunningFilter event", runningFilter, runningFilterLocal);
        handleData();
    }

    const handleCalculatedEndFilter = (event, newValue) => {

        var value = calculatedEndFilter.toString() === "true" ? true : false;
        //invert boolean string value
        value = value === true ? false : true;
        setCalculatedEndFilter(value);
        //set to boolean for local variable
        calculatedEndFilterLocal = value === true;

        console.log("handleCalculatedEndFilter event", calculatedEndFilter, calculatedEndFilterLocal);

        handleData();
    }

    const handleShowReplanned = (event, newValue) => {
        //console.log("handleShowReplanned event", event.target.checked);
        var value = showReplanned;
        value = value === true ? false : true;
        setShowReplanned(value);
        showReplannedLocal = value === true;

        // setShowReplanned(event.target.checked);
        // showReplannedLocal = event.target.checked;
        handleData();
    }

    const handleShowMain = (event, newValue) => {
        //console.log("handleShowMain event", event.target.checked);
        var value = showMain;
        value = value === true ? false : true;
        setShowMain(value);
        showMainLocal = value === true;
        // setShowMain(event.target.checked);
        // showMainLocal = event.target.checked;
        handleData();
    }

    const handleShowUnsaved = (event, newValue) => {
        console.log("handleShowUnsaved event", event.target, newValue, showUnsaved);
        var value = showUnsaved;
        value = value === true ? false : true;
        setShowUnsaved(value);
        showUnsavedLocal = value === true;
        // setShowUnsaved(event.target.checked);
        // showUnsavedLocal = event.target.checked;
        handleData();
    }



    const handleShowCalendar = (event, newValue) => {
        //console.log("handleShowMain event", event.target.checked);
        var value = showCalendar;
        value = value === true ? false : true;
        setShowCalendar(value);
        showCalendarLocal = value === true;
        // setShowCalendar(event.target.checked);
        // showCalendarLocal = event.target.checked;
        handleData();
    }

    // #################
    let capacityQuery = {
        data: [
            {
                id: 1,
                title: "Capacity 1" //translateStatus(status.text, 1)
            },
            {
                id: 2,
                title: "Capacity 2"
            },
        ]
    }

    let groupingQuery = {
        data: [
            {
                id: "0",
                title: "Machines" //translateStatus(status.text, 1)
            },
            {
                id: "1",
                title: "Area" //translateStatus(status.text, 1)
            },
            // {
            //     id: 2,
            //     title: "Capacity"
            // },
            // {
            //     id: 3,
            //     title: "Machine type"
            // },
        ]
    }

    const rotatedStyle = {
        transform: 'rotate(-90deg)',
        // transformOrigin: 'left top',
        // position: 'absolute',
        // top: '100px',
        // left: '100px',
        // fontSize: '20px',
        // backgroundColor: 'lightblue',
        // padding: '10px',
        color: '#fff',
        //backgroundColor: '#ff00ff',
        // width: '10px',
        //height: '10px',
    };


    // console.log("areaFilter", areaFilter);
    // console.log("machineFilter", machineFilter);
    //console.log("prodPlanQuery", prodPlanQuery.data);

    function isActivePO(pPO, pActivePO) {
        if (pPO !== undefined && pPO !== null && pActivePO !== undefined && pActivePO !== null) {
            if (pPO.toString() === pActivePO.toString()) {
                return true; // This is the active production order
            }
        }
        return false;
    }


    const ms = (d) => new Date(d).getTime();

    // ----- Calculate the planned data for the Gantt chart -----
    function handleData() {

        let startDatesPerMachine = [];
        if (prodPlanQuery.data !== undefined) {
            //get startdate for current PO / machine

            prodPlanQuery.data.forEach((item) => {
                item.productionPlans.forEach((plan) => {
                    if (isActivePO(plan.productionOrderId, item.activeProductionOrder)) {
                        let startDateForMachine = dayjs(plan.replannedStartTime ?? plan.plannedStartTime).format(isoFormat);
                        if (startDatesPerMachine.findIndex(x => x.machineId === item.machineId) === -1) {
                            startDatesPerMachine.push({
                                machineId: item.machineId,
                                startDate: startDateForMachine
                            });
                        }
                    };
                });
            });
        }


        let localData =

            [{
                // "actualStart": "2025-05-18",
                // "actualEnd": "2025-06-18",
                // "baselineStart": "2025-05-18",
                // "baselineEnd": "2025-06-20",
                "children": [],
                "collapsed": "false",
                "id": "6",
                "name": formatMessage(messages.machines),
                "rowHeight": 23
            }]
            ;

        let children = [];

        //console.log("handleData prodPlanQuery.data", prodPlanQuery.data);

        if (prodPlanQuery.data !== undefined) {
            children = prodPlanQuery.data.map((item) => {

                return {
                    "collapsed": "false",
                    "id": item.machineId,
                    "name": item.machineName,
                    "areaKey": item.productionPlans?.[0]?.machine?.areaKey,
                    "capacity": item.capacity, // not available?
                    "machineTypeId": item.productionPlans?.[0]?.machine?.machineTypeId,
                    "machineStatus": item.productionPlans?.[0]?.machine?.machineStatus,
                    "machinePriorityId": item.machinePriorityId,
                    "machinePriorityIcon": item.machinePriorityIcon,
                    "speedUnitTypeId": item?.speedUnitTypeId,
                    "rowType": "main",
                    "isMarkedForUpdate": false,
                    "activeProductionOrder": item.activeProductionOrder,
                    "periods": item.productionPlans.reduce((acc, period) => {


                        //####
                        // if (period.erpStatus === "999"){
                        //     console.log ("period.erpStatus is 999 (Machine)", item.machineName, period.productionOrderId, period.replannedStartTime , period.plannedStartTime);
                        // }

                        let duration = dayjs(period.replannedEndTime ?? period.plannedEndTime).diff(dayjs(period.replannedStartTime ?? period.plannedStartTime), 'minute');
                        let durationRelative = (duration * period.reportedQty / period.plannedQty);
                        let producedPercent = (durationRelative / duration);
                        let progEnd = dayjs(period.replannedStartTime ?? period.plannedStartTime).add(durationRelative, 'minute');
                        if (progEnd.isAfter(dayjs()) && dayjs(period.replannedStartTime ?? period.plannedStartTime).isBefore(dayjs()) && producedPercent > 1) {
                            progEnd = dayjs();
                        }

                        // Get current OEE for running order and planned order
                        let currentOEE = defaultOee;
                        if (isActivePO(period.productionOrderId, item.activeProductionOrder)) {
                            currentOEE = getOeeForRunningOrder(period.productionOrderId);
                        } else {
                            // currentOEE = getLatestHistoricOee(period.itemNo) || defaultOee;
                            //Use selected OEE value from production plan info if available, otherwise fallback to historic OEE or default OEE
                            currentOEE = period.productionPlanInfo?.oeeValue || defaultOee;
                        }

                        //calculated end time based on ideal speed remaing qty and OEE
                        let calculatedEndTime = ReCalculateEndTime(period, item.speedUnitTypeId, currentOEE);
                        let calcEndTime = calculatedEndTime.calcEndTime;
                        let idealTimeToEnd = calculatedEndTime.idealTimeToEnd;
                        let idealRunTime = calculatedEndTime.idealRunTime;

                        //For prognosis calculate the end time based on current time and ideal cycle time and OEE and calendar
                        //let {replannedItem, replannedOrders} = ReplanMachine2(period,[period], item.machineName, gapInMinutes,false, true, false, companyKey, scheduleRowsQuery.data, historicOeeDataQuery.data, defaultOee);
                        //let prognosisEndTime = replannedItem?.calculatedEndTime || null;

                        //console.log ("Prognosis calculated end time for period ", period.productionOrderId, " on machine ", item.machineName, " is ", prognosisEndTime, "replannedOrders:", replannedOrders);

                        // Default object for the period
                        let defaultObj = {
                            "color": "#ff00ff",
                            "start": null, //period.replannedStartTime ?? period.plannedStartTime,
                            "end": null, //calcEndTime,
                            "plannedStartTime": period.plannedStartTime,
                            "plannedEndTime": period.plannedEndTime,
                            "replannedStartTime": period.replannedStartTime,
                            "replannedEndTime": period.replannedEndTime,
                            "productionOrderId": period.productionOrderId,
                            "activePO": item.activeProductionOrder.trim(),
                            "machineId": item.machineId,
                            "ongoing": false,
                            "plannedQty": period.plannedQty,
                            "reportedQty": period.reportedQty,
                            "scrappedQty": period.scrappedQty,
                            "idealCycleTime": period.idealCycleTime,
                            "actualCycleTime": period.cycleTimes,
                            "itemNo": period.itemNo,
                            "itemName": period.itemName,
                            "plannedProductionTime": period.plannedProductionTime,
                            "actualProductionTime": period.actualProductionTime,
                            "actualStartTime": period.actualStartTime,
                            "actualEndTime": period.actualEndTime,
                            "calculatedStartTime": "",
                            "calculatedEndTime": "",
                            "plannedOrReplannedStartTime": dayjs(period.replannedStartTime ?? period.plannedStartTime).format(isoFormat),
                            "plannedOrReplannedEndTime": dayjs(period.replannedEndTime ?? period.plannedEndTime).format(isoFormat),
                            // "actualStart": period.replannedStartTime ?? period.plannedStartTime,
                            // "actualEnd": period.replannedEndTime ?? period.plannedEndTime,
                            // "baselineStart": period.replannedStartTime ?? period.plannedStartTime,
                            // "baselineEnd": period.replannedEndTime ?? period.plannedEndTime,
                            "id": period.id,
                            "periodId": period.id,
                            "tool": period.tool,
                            "cavity": period.cavity,
                            "speedUnitTypeId": item.speedUnitTypeId,
                            "type": null, // "calc"
                            "erpStatus": period.erpStatus,
                            "calculatedTimeToEnd": idealTimeToEnd,
                            "calculatedRunTime": idealRunTime,
                            "editing": period.editing,
                            "rowType": period.rowType,
                            "blockerDescription": period.productionPlanBlocker?.description,
                            "blockerColor": period.productionPlanBlocker?.color,
                            "extended": false,
                            // "historicOee": period.historicOee,
                            "oeeValue": period.productionPlanInfo?.oeeValue,
                            "oeeCalculationType": period.productionPlanInfo?.oeeCalculationType,

                        }

                        let calcStart = "";
                        let calcEnd = "";

                        let currentPOStartDateObj = startDatesPerMachine.find(x => x.machineId === item.machineId);
                        if (!currentPOStartDateObj) {
                            currentPOStartDateObj = { machineId: item.machineId, startDate: dayjs().format(isoFormat) };
                        }

                        //####
                        // if (period.erpStatus === "999") {
                        //     console.log("period.erpStatus is 999 (Machine)", item.machineName, period.productionOrderId, period.replannedStartTime, period.plannedStartTime);
                        // }



                        // Calculated end time
                        if (item.activeProductionOrder?.toString().trim() === period.productionOrderId?.toString().trim() || dayjs(defaultObj.plannedOrReplannedStartTime).isAfter(dayjs(currentPOStartDateObj.startDate))) {// && (period.reportedQty < period.plannedQty || period.plannedQty === 0)) {

                            calcStart = period.replannedStartTime ?? period.plannedStartTime;
                            calcEnd = calcEndTime;

                            if (isFeatureEnabled(featuresQuery, "ProductionPlanningShowCalculatedEnd") && calculatedEndFilterLocal && editLocal.toString() === "false") {

                                //show enlongated block only if anything left to produce
                                if ((period.plannedQty - period.reportedQty) >= 0 && period.erpStatus !== 9) {

                                    //Dont show enlongated block if calculated time less than planned
                                    //if (dayjs(calcEndTime).isAfter(dayjs(defaultObj.plannedOrReplannedEndTime))) {

                                    //console.log("starting:", period.productionOrderId, " on machine ", item.machineName, " is ", calcEndTime, idealRunTime);
                                    //console.log("starting2:", period.replannedStartTime, period.plannedStartTime, dayjs(calcStart).format(isoFormat));

                                    // if starttime is less than now and adjusted end time is in the future, set adjusted start time to now to show the block as currently ongoing
                                    var adjustedStartTime = calcStart;
                                    if (dayjs(calcStart).isBefore(dayjs())) {
                                        adjustedStartTime = dayjs();
                                    }

                                    // Calculate end time based on availabe scheduled work time (calendar) and OEE
                                    let adjustedEndTime = placeWithShiftsAndBlockers({
                                        startMs: ms(dayjs(adjustedStartTime).format(isoFormat)),
                                        workDurationMs: idealTimeToEnd * 60 * 1000,
                                        shifts: machineShifts.find(x => x.machineId === item.machineId)?.shifts || [],
                                        blockers: machineBlockers.find(x => x.machineId === item.machineId)?.blockers || [],
                                        gapMs: gapInMinutes * 60 * 1000,
                                        label: "Calculated end time",
                                    });

                                    if (adjustedEndTime) {
                                        acc.push({
                                            ...defaultObj,
                                            start: dayjs(calcStart).format(isoFormat),
                                            end: dayjs(adjustedEndTime?.end).format(isoFormat),
                                            calculatedStartTime: calcStart,
                                            calculatedEndTime: dayjs(adjustedEndTime?.end).format(isoFormat),
                                            type: "calc"
                                        });
                                    }

                                    // }
                                } else {

                                    // console.log ("Not adding calculated end time as plannedQty - reportedQty <= 0", item.machineName, period.productionOrderId, period.plannedQty, period.reportedQty);
                                }
                            }
                        }
                        // The main period
                        acc.push({
                            ...defaultObj,
                            start: dayjs(period.replannedStartTime ?? period.plannedStartTime).format(isoFormat),
                            end: dayjs(period.replannedEndTime ?? period.plannedEndTime).format(isoFormat),
                            calculatedStartTime: calcStart,
                            calculatedEndTime: calcEnd,
                            type: "main"
                        });
                        // Progress bar
                        if (period.rowType === 1 && edit.toString() === "false") { // No progress for blockers
                            acc.push({
                                ...defaultObj,
                                start: dayjs(period.replannedStartTime ?? period.plannedStartTime).format(isoFormat),
                                end: dayjs(progEnd).format(isoFormat),
                                calculatedStartTime: calcStart,
                                calculatedEndTime: calcEnd,
                                type: "prog"
                            });
                        }
                        return acc;
                    }, []),
                    "rowHeight": 23
                }
            })
        }

        localData[0].children = children;

        //Group by area
        if (groupByLocal.toString() === "1") {

            //console.log("Grouping by area");

            let distinctAreas = [];

            distinctAreas = prodPlanQuery.data?.map((plan) => {
                return plan.productionPlans?.[0]?.machine?.areaKey;
            });
            distinctAreas = [...new Set(distinctAreas)]; // Remove duplicates

            //sort areas as numbers
            distinctAreas = distinctAreas.sort((a, b) => {
                const aNum = parseInt(a, 10);
                const bNum = parseInt(b, 10);
                return aNum - bNum;
            });

            let localDataAreaGrouped = [];
            distinctAreas.forEach((area) => {
                let areaData = {
                    "children": [],
                    "collapsed": "false",
                    "id": area.toString(),
                    "name": getAreaNameById(area),
                    "rowHeight": 23
                };

                let areaChildren = prodPlanQuery.data.filter(item => item.areaKey === area).map((item) => {
                    return {
                        "collapsed": "false",
                        "id": item.machineId,
                        "name": item.machineName,
                        "areaKey": item.productionPlans?.[0]?.machine?.areaKey,
                        "capacity": item.capacity, // not available?
                        "machineTypeId": item.productionPlans?.[0]?.machine?.machineTypeId,
                        "machineStatus": item.productionPlans?.[0]?.machine?.machineStatus,
                        "machinePriorityId": item.machinePriorityId,
                        "machinePriorityIcon": item.machinePriorityIcon,
                        "speedUnitTypeId": item?.speedUnitTypeId,
                        "rowType": "main",
                        "isMarkedForUpdate": false,
                        "activeProductionOrder": item.activeProductionOrder,
                        "periods": item.productionPlans.reduce((acc, period) => {

                            let duration = dayjs(period.replannedEndTime ?? period.plannedEndTime).diff(dayjs(period.replannedStartTime ?? period.plannedStartTime), 'minute');
                            let durationRelative = (duration * period.reportedQty / period.plannedQty);
                            let producedPercent = (durationRelative / duration);
                            let progEnd = dayjs(period.replannedStartTime ?? period.plannedStartTime).add(durationRelative, 'minute');
                            if (progEnd.isAfter(dayjs()) && dayjs(period.replannedStartTime ?? period.plannedStartTime).isBefore(dayjs()) && producedPercent > 1) {
                                progEnd = dayjs();
                            }

                            // Get current OEE for running order and planned order
                            let currentOEE = defaultOee;
                            if (isActivePO(period.productionOrderId, item.activeProductionOrder)) {
                                currentOEE = getOeeForRunningOrder(period.productionOrderId);
                            } else {
                                //currentOEE = item?.historicOee / 100 || defaultOee;
                                //Use selected OEE value from production plan info if available, otherwise fallback to historic OEE or default OEE
                                currentOEE = period.productionPlanInfo?.oeeValue || defaultOee;
                            }

                            //calculated end time based on ideal speed remaing qty and OEE
                            let calculatedEndTime = ReCalculateEndTime(period, item.speedUnitTypeId, currentOEE);
                            let calcEndTime = calculatedEndTime.calcEndTime;
                            let idealTimeToEnd = calculatedEndTime.idealTimeToEnd;
                            let idealRunTime = calculatedEndTime.idealRunTime;

                            let defaultObj = {
                                // return {
                                "color": "#ff00ff",
                                "start": null, //period.replannedStartTime ?? period.plannedStartTime,
                                // now + time to finished
                                "end": null, //calcEndTime,
                                "plannedStartTime": period.plannedStartTime,
                                "plannedEndTime": period.plannedEndTime,
                                "replannedStartTime": period.replannedStartTime,
                                "replannedEndTime": period.replannedEndTime,
                                "productionOrderId": period.productionOrderId,
                                "activePO": item.activeProductionOrder.trim(),
                                "machineId": item.machineId,
                                "ongoing": false,
                                "plannedQty": period.plannedQty,
                                "reportedQty": period.reportedQty,
                                "scrappedQty": period.scrappedQty,
                                "idealCycleTime": period.idealCycleTime,
                                "actualCycleTime": period.cycleTimes,
                                "itemNo": period.itemNo,
                                "itemName": period.itemName,
                                "plannedProductionTime": period.plannedProductionTime,
                                "actualProductionTime": period.actualProductionTime,
                                "actualStartTime": period.actualStartTime,
                                "actualEndTime": period.actualEndTime,
                                "calculatedStartTime": "",
                                "calculatedEndTime": "",
                                "plannedOrReplannedStartTime": dayjs(period.replannedStartTime ?? period.plannedStartTime).format(isoFormat),
                                "plannedOrReplannedEndTime": dayjs(period.replannedEndTime ?? period.plannedEndTime).format(isoFormat),
                                // "actualStart": period.replannedStartTime ?? period.plannedStartTime,
                                // "actualEnd": period.replannedEndTime ?? period.plannedEndTime,
                                // "baselineStart": period.replannedStartTime ?? period.plannedStartTime,
                                // "baselineEnd": period.replannedEndTime ?? period.plannedEndTime,
                                "id": period.id,
                                "periodId": period.id,
                                "tool": period.tool,
                                "cavity": period.cavity,
                                "speedUnitTypeId": item.speedUnitTypeId,
                                "type": null, // "calc"
                                "erpStatus": period.erpStatus,
                                "calculatedTimeToEnd": idealTimeToEnd,
                                "calculatedRunTime": idealRunTime,
                                "editing": period.editing,
                                "rowType": period.rowType,
                                "blockerDescription": period.productionPlanBlocker?.description,
                                "blockerColor": period.productionPlanBlocker?.color,
                                "extended": false,
                                // "historicOee": period.historicOee,
                                "oeeValue": period.productionPlanInfo?.oeeValue,
                                "oeeCalculationType": period.productionPlanInfo?.oeeCalculationType,
                            }

                            let calcStart = "";
                            let calcEnd = "";

                            let currentPOStartDateObj = startDatesPerMachine.find(x => x.machineId === item.machineId);
                            if (!currentPOStartDateObj) {
                                currentPOStartDateObj = { machineId: item.machineId, startDate: dayjs().format(isoFormat) };
                            }


                            //####
                            // if (period.erpStatus === "999") {
                            //     console.log("period.erpStatus is 999 (Area)", item.machineName, period.productionOrderId, period.replannedStartTime, period.plannedStartTime);
                            // }

                            // Calculated end time
                            if (item.activeProductionOrder?.toString().trim() === period.productionOrderId?.toString().trim() || dayjs(defaultObj.plannedOrReplannedStartTime).isAfter(dayjs(currentPOStartDateObj.startDate))) {// && (period.reportedQty < period.plannedQty || period.plannedQty === 0)) {


                                calcStart = period.replannedStartTime ?? period.plannedStartTime;
                                calcEnd = calcEndTime;

                                if (isFeatureEnabled(featuresQuery, "ProductionPlanningShowCalculatedEnd") && calculatedEndFilterLocal && editLocal.toString() === "false") {

                                    //show enlongated block only if anything left to produce
                                    if ((period.plannedQty - period.reportedQty) > 0 && period.erpStatus !== 9) {

                                        //Dont show enlongated block if calculated time less than planned
                                        //if (dayjs(calcEndTime).isAfter(dayjs(defaultObj.plannedOrReplannedEndTime))) {

                                        // Calculate end time based on availabe scheduled work time (calendar) and OEE
                                        let adjustedEndTime = placeWithShiftsAndBlockers({
                                            startMs: ms(dayjs(calcStart).format(isoFormat)),
                                            workDurationMs: idealRunTime * 60 * 1000,
                                            shifts: machineShifts.find(x => x.machineId === item.machineId)?.shifts || [],
                                            blockers: machineBlockers.find(x => x.machineId === item.machineId)?.blockers || [],
                                            gapMs: gapInMinutes * 60 * 1000,
                                            label: "Calculated end time",
                                        });

                                        //console.log("Adjusted: ", period.productionOrderId, " on machine ", item.machineId, item.machineName, " is ", calcEndTime, adjustedEndTime, idealRunTime);

                                        //if (adjustedEndTime && dayjs(adjustedEndTime.end).isAfter(dayjs(defaultObj.plannedOrReplannedEndTime))) {
                                        if (adjustedEndTime) {
                                            acc.push({
                                                ...defaultObj,
                                                start: dayjs(calcStart).format(isoFormat),
                                                end: dayjs(adjustedEndTime?.end).format(isoFormat),
                                                calculatedStartTime: calcStart,
                                                calculatedEndTime: dayjs(adjustedEndTime?.end).format(isoFormat),
                                                type: "calc"
                                            });
                                        }

                                        // }
                                    } else {

                                        // console.log ("Not adding calculated end time as plannedQty - reportedQty <= 0", item.machineName, period.productionOrderId, period.plannedQty, period.reportedQty);
                                    }
                                }
                            }
                            // The main period
                            acc.push({
                                ...defaultObj,
                                start: dayjs(period.replannedStartTime ?? period.plannedStartTime).format(isoFormat),
                                end: dayjs(period.replannedEndTime ?? period.plannedEndTime).format(isoFormat),
                                calculatedStartTime: calcStart,
                                calculatedEndTime: calcEnd,
                                type: "main"
                            });
                            // Progress bar
                            if (period.rowType === 1 && edit.toString() === "false") { // No progress for blockers
                                acc.push({
                                    ...defaultObj,
                                    start: dayjs(period.replannedStartTime ?? period.plannedStartTime).format(isoFormat),
                                    end: dayjs(progEnd).format(isoFormat),
                                    calculatedStartTime: calcStart,
                                    calculatedEndTime: calcEnd,
                                    type: "prog"
                                });
                            }

                            return acc;
                        }, []),
                        "rowHeight": 23
                    }
                })

                areaData.children = areaChildren;
                if (areaData?.children?.length > 0) {
                    localDataAreaGrouped.push(areaData);
                }

            });

            localData = localDataAreaGrouped;

        }

        // Get unfiltered data for machine list

        // Apply filters
        if (machineFilterLocal.length > 0) {
            //console.log("filtering on Machines", machineFilter);
            let machines = machineFilterLocal?.map(m => m.id)
            localData.forEach(area => {
                area.children = area.children?.filter(child => machines.includes(child.id));
            });
        }

        if (areaFilterLocal.length > 0) {
            // console.log("filtering on Area", areaFilter);
            let areas = areaFilterLocal?.map(a => a.id)
            //Remove all unselected areas
            // console.log("Filtered Areas count before", localData);
            //localData = localData.filter(area => area.children.length > 0);
            // console.log("Filtered Areas count", localData);

            localData.forEach(area => {
                area.children = area.children?.filter(child => areas.includes(child.areaKey));
            });
        }

        //Get unfiltered data for machine list. Dont include the running filter
        const deepClone = JSON.parse(JSON.stringify(localData));
        setUnfilteredData(deepClone);

        if (runningFilterLocal === true) {
            //console.log("Filtering on Running");
            localData.forEach(item => {
                // item.children = item.children?.filter(child => child.productionOrderId === child.activePO);
                item.children?.forEach(child => child.periods = child.periods?.filter(period => period.productionOrderId.toString() === period.activePO.toString()));
            });
        }

        //Show only replanned rows
        if (showUnsavedLocal === true) {
            localData.forEach(item => {
                // item.children = item.children?.filter(child => child.productionOrderId === child.activePO);
                item.children?.forEach(child => child.periods = child.periods?.filter(period => period.editing === true));
            });
        }

        //Show suggested replanning based on current OEE and ideal cycle time and remaining qty
        if (showReplannedLocal === true) {
            //console.log("!!localData", localData);
            if (localData.length > 0 && localData[0].children.length > 0) {
                localData[0].children.forEach(child => {

                    let firstMachine = child;
                    let firstMachineClone = JSON.parse(JSON.stringify(firstMachine));
                    firstMachineClone.name = firstMachineClone.name + " (rep)";
                    firstMachineClone.rowType = "replanned";

                    //recalculate periods so that each period starts where the one before ends
                    firstMachineClone.periods = firstMachineClone.periods.filter(period => period.type === "main");

                    //sort periods by start date using dayjs and productionorder id
                    firstMachineClone.periods = firstMachineClone.periods.sort((a, b) => a.productionOrderId - b.productionOrderId);
                    firstMachineClone.periods = firstMachineClone.periods.sort((a, b) => dayjs(a.start).isAfter(dayjs(b.start)) ? 1 : -1);

                    //get first uptime for current running order for machine
                    const firstUptime = getOrderFirstTimeStamp(firstMachineClone.activeProductionOrder);

                    //let replannedMachine = SuggestReplanningForMachine(firstMachineClone, gapInMinutes, false, true, false, scheduleRowsQuery, historicOeeDataQuery, defaultOee, companyKey);
                    let replannedMachine = GetSuggestedPlanningForMachine(firstMachineClone, gapInMinutes, true, scheduleRowsQuery.data, historicOeeDataQuery.data, defaultOee, firstUptime);

                    // console.log(firstMachineClone.name + " Replanned machine periods0:", { ...replannedMachine });
                    //If no running PO found, get the first non completed PO and start from that
                    // console.log(firstMachineClone.name + " Checking if replannedMachine has any non-blocker periods:", replannedMachine.periods.filter(x => x.rowType !== 2)?.length);
                    if (replannedMachine.periods.filter(x => x.rowType !== 2)?.length === 0) {
                        //replannedMachine = SuggestReplanningForMachine(firstMachineClone, gapInMinutes, false, true, false, scheduleRowsQuery, historicOeeDataQuery, defaultOee, companyKey);
                        replannedMachine = GetSuggestedPlanningForMachine(firstMachineClone, gapInMinutes, false, scheduleRowsQuery.data, historicOeeDataQuery.data, defaultOee, firstUptime);
                    }

                    if (replannedMachine.periods.length > 0) {
                        localData[0].children.push(replannedMachine);
                    }

                });

            }
        }

        // show calendar planned shifts
        if (showCalendarLocal === true) {
            if (localData.length > 0 && localData[0].children.length > 0) {

                let mainRows = localData[0].children.filter(row => row.rowType === "main");

                //console.log("[Debug] localDataMain", localData[0].children);

                mainRows.forEach(machine => {

                    let firstMachine = machine;
                    let firstMachineClone = JSON.parse(JSON.stringify(firstMachine));
                    firstMachineClone.name = firstMachineClone.name + " (cal)";
                    firstMachineClone.rowType = "shift";

                    let machineCalendar = scheduleRowsQuery?.data?.data.filter(cal => cal.machineId === machine.id);
                    let shifts = machineCalendar?.map(shift => {
                        return {
                            "productionOrderId": shift.templateName?.charAt(0) || "",
                            "color": shift.templateColor || "#808080",
                            "start": dayjs(shift.startDate).format(isoFormat),
                            "end": dayjs(shift.endDate).format(isoFormat),
                            "plannedStartTime": dayjs(shift.startDate).format(isoFormat),
                            "plannedEndTime": dayjs(shift.endDate).format(isoFormat),
                            "type": "calendar",
                            "shiftName": shift.templateName || "",
                        };
                    });

                    firstMachineClone.periods = shifts;

                    if (shifts?.length > 0) {
                        localData[0].children.push(firstMachineClone);
                    }
                });
            }
        }

        //sort by machine name
        localData.forEach(area => {
            area.children = area.children?.sort((a, b) => a.name.localeCompare(b.name));
        });

        //remove main rows
        //console.log("!!localData", localData, showMainLocal);
        if (showMainLocal === false) {
            localData[0].children = localData[0]?.children?.filter(row => row.rowType === "replanned");
        }



        //console.log("Filtered Local Data:", localData);

        //Remove empty areas
        localData = localData.filter(area => area?.children?.length > 0);

        // Update the plannedData state with the filtered data
        setPlannedData(localData);

        //console.log ("localData", localData );


        //console.log("prodPlanQuery.data", prodPlanQuery.data);
        // console.log("plannedData", plannedData);
        // console.log("machineFilter", machineFilter);
        //console.log("OeeDataQuery.data", OeeDataQuery.data);
    }


    //console.log("plannedData", plannedData);
    //console.log("machineQuery", machineQuery?.data)
    //console.log ("areaQuery", areaQuery?.data);
    //console.log("prodPlanQuery.data", prodPlanQuery.data);
    //console.log ("unfilteredData", unfilteredData);
    //console.log("groupBy", groupBy);
    //console.log("plannedData", plannedData);
    //console.log("OeeDataQuery", OeeDataQuery?.data);
    //console.log("OeeDataQuery100Days", OeeDataQuery100Days?.data);
    //console.log("scheduleRowsQuery", scheduleRowsQuery?.data);


    //--------------------------------------------

    //let alarms = openActivitiesQuery.data?.filter((list) => list.type === 2 && list.activityStatusId === 1);
    let alarms = [];
    return <>
    
        <Box
            m="20px"
            sx={{
                backgroundColor: colors.primary[700],
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 95px)",
                overflow: "hidden",
            }}
        >
            <Box p={1} display="flex" justifyContent="space-between" alignItems="center" sx={{ flexShrink: 0 }}>
                {alarms.length > 0 &&
                    <Box marginBottom="10px"><AlarmBanner alarms={alarms} /></Box>
                }

                {/* 
                <Grid container spacing="auto" sx={{ paddingTop: "5px" }}>
                    <Grid item xs={12} lg={4}> */}

                <Stack direction="row" display="flex" alignItems="center" spacing="auto" width="100%">

                    <Stack direction="row" width="60%" marginLeft={0} spacing={2} >
                        {/* <Box marginLeft="30px" justifyContent="flex-end" justifyItems="flex-end" display="flex"><div style={rotatedStyle}>Filter</div></Box> */}

                        {/* <Box sx={{ width: 50, marginLeft: 2 }}> */}

                        <Box sx={{ border: `2px solid ${colors.gray[400]}`, borderRadius: '5px', width: '55px', height: '55px' }} display="flex" justifyContent="center" alignItems="center">
                            <Tooltip title={showList ? "Switch to Gantt view" : "Switch to List view"} arrow>
                                <IconButton
                                    onClick={() => {
                                        setShowList(!showList);
                                    }}
                                >
                                    {showList === true ?
                                        <ListIcon></ListIcon> :
                                        <ViewCompactOutlinedIcon></ViewCompactOutlinedIcon>
                                    }
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Box sx={{ border: `2px solid ${colors.gray[400]}`, borderRadius: '5px', width: '55px', height: '55px' }} display="flex" justifyContent="center" alignItems="center">
                            <Tooltip title="Add Production order" arrow>
                                <IconButton
                                    onClick={() => {
                                        handleOpenNewPO();
                                    }}
                                >
                                    <AddCircleIcon></AddCircleIcon>
                                </IconButton>
                            </Tooltip>

                        </Box>

                        <Box sx={{ width: 200, marginLeft: 2 }}>
                            <AxionControls.AxionAutocomplete

                                name="Machine" //{props.recurringSchedule.multipleMachineIds === true ? "machineIds" : "machineId"}
                                label={formatMessage(messages.machines)}//"Machine" // {<FormattedMessage {...messages.machinePlaceholder} />}
                                multiple={true} //{props.recurringSchedule.multipleMachineIds === true ? true : false}
                                defaultValue={machineFilter || ""}//{filteredMachines.filter((machine) => props.recurringSchedule?.machineId === machine.id).map((machine) => ({ id: machine.id, title: machine.machineName }))[0]}
                                value={machineFilter || ""}
                                options={machineQuery.data.map((machine) => ({
                                    id: machine.id,
                                    title: machine.machineName //translateStatus(status.text, 1)
                                }))}
                                onChange={(event, newValue) => {
                                    handleMachinesFilter(event, newValue);
                                    //setMachineFilter(event.target.value)
                                    //props.recurringSchedule.multipleMachineIds === true ? props.onChange({ target: { id: "machineIds", value: newValue?.map(v => v.id) } }) : props.onChange({ target: { id: "machineId", value: newValue?.id } });
                                }}
                                backgroundColor={colors.primary[700]}
                                borderColor={colors.gray[400]}
                                color={colors.gray[200]}
                            />
                        </Box>

                        <Box sx={{ width: 200, marginLeft: 2 }}>
                            <AxionControls.AxionAutocomplete
                                name="Area" //{props.recurringSchedule.multipleMachineIds === true ? "machineIds" : "machineId"}
                                label={formatMessage(messages.areas)}//"Area" // {<FormattedMessage {...messages.machinePlaceholder} />}
                                multiple={true} //{props.recurringSchedule.multipleMachineIds === true ? true : false}
                                defaultValue={areaFilter || ""}//defaultValue={filteredMachines.filter((machine) => props.recurringSchedule?.machineId === machine.id).map((machine) => ({ id: machine.id, title: machine.machineName }))[0]}
                                value={areaFilter || ""}
                                options={areaQuery.data
                                    .filter(x => x.companyKey === companyKey)
                                    .sort((a, b) => a.areaName.localeCompare(b.areaName))
                                    .map((area) => ({
                                        id: area.areaKey,
                                        title: area.areaName //translateStatus(status.text, 1)
                                    }))}
                                onChange={(event, newValue) => {
                                    handleAreaFilter(event, newValue);
                                    //props.recurringSchedule.multipleMachineIds === true ? props.onChange({ target: { id: "machineIds", value: newValue?.map(v => v.id) } }) : props.onChange({ target: { id: "machineId", value: newValue?.id } });
                                }}
                                backgroundColor={colors.primary[700]}
                                borderColor={colors.gray[400]}
                                color={colors.gray[200]}
                            />
                        </Box>


                        {/* <div with="30px" style={rotatedStyle}>Group </div> */}
                        <Box width="30px"></Box>
                        <Box sx={{ width: 250, marginLeft: 4, alignItems: "center", justifyContent: "center", display: "flex" }}>


                            {/* <AxionControls.AxionAutocomplete
                                name="GroupBy" //{props.recurringSchedule.multipleMachineIds === true ? "machineIds" : "machineId"}
                                label="Group by"//"Area" // {<FormattedMessage {...messages.machinePlaceholder} />}
                                multiple={false} //{props.recurringSchedule.multipleMachineIds === true ? true : false}
                                defaultValue={groupBy || ""}//defaultValue={filteredMachines.filter((machine) => props.recurringSchedule?.machineId === machine.id).map((machine) => ({ id: machine.id, title: machine.machineName }))[0]}
                                value={groupBy || ""} //{props.statusFilter}
                                //showNoneOption={true}
                                //noneText="No grouping" //{<FormattedMessage {...messages.allOption} />}
                                options={groupingQuery.data.map((type) => ({
                                    id: type.id,
                                    title: type.title //translateStatus(status.text, 1)
                                }))}
                                onChange={(event, newValue) => {
                                    console.log("Group by changed:", newValue);
                                    setGroupBy(newValue?.id || 0);
                                    groupByLocal = newValue?.id || 0;
                                    handleData();
                                }}
                                backgroundColor={colors.primary[700]}
                                borderColor={colors.gray[400]}
                                color={colors.gray[200]}
                            /> */}

                            <FormControl fullWidth>
                                <InputLabel id="select-label">Group by</InputLabel>
                                <Select
                                    name="GroupBy"
                                    label={formatMessage(messages.groupBy)}
                                    labelId="select-label"
                                    sx={{ width: "200px", border: `2px`, borderColor: colors.gray[400] }}
                                    width="200px"
                                    //disabled={true}
                                    initialValue={groupBy || ""}
                                    value={groupBy || ""}
                                    // options={props.machineQuery?.map((machine) => ({
                                    //     id: machine.id,
                                    //     title: machine.machineName,
                                    // }))}
                                    // onChange={(event) => {
                                    //     setMachineId(event.target.value);
                                    //     console.log("Selected machine:", event.target.value);
                                    // }}

                                    onChange={(event) => {
                                        //console.log("Group by changed:", event.target.value);
                                        setGroupBy(event.target.value || "");
                                        groupByLocal = event.target.value || "";
                                        handleData();
                                    }}
                                    backgroundColor={colors.primary[700]}
                                    borderColor={colors.gray[400]}

                                //color={colors.gray[200]}


                                >
                                    {groupingQuery.data.map((g) => (
                                        <MenuItem key={g.id} value={g.id}>
                                            {g.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>




                            {/* <Select
                                name="grouperBy"
                                label="GroupBy"
                                initialValue={groupBy || ""}
                                value={groupBy || ""}
                                sx={{ width: "300px" }}
                                // backgroundColor={colors.primary[700]}
                                // borderColor={colors.gray[400]}
                                // color={colors.gray[200]}
                                onChange={(e) => {
                                    setGroupBy(e.target.value);
                                    groupByLocal = e.target.value;
                                    handleData();
                                }}
                            >
                                <MenuItem key={0} value={0}>No grouping</MenuItem>
                                {groupingQuery.data.map((m) => (
                                    <MenuItem key={m.id} value={m.id}>
                                        {m.title}
                                    </MenuItem>
                                ))}


                            </Select> */}


                        </Box>

                    </Stack>

                    {/* </Grid>
                    <Grid item xs={12} lg={8}> */}
                    <Box flexGrow={1} />
                    {/* move to the far right */}
                    <Stack direction="row" marginLeft={2} spacing={2} display="flex" alignItems="flex-end" justifyItems="flex_end" justifyContent="flex-end" alignContent="flex-end" >
                        {/* <Box onClick={getWeekData} width="100px">This week</Box>
                        <Box onClick={getMonthData} width="100px">This month</Box> */}
                        <Box>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel
                                        value="currentShift"
                                        control={<Radio {...controlProps("week")} sx={{
                                            color: "secondary",
                                            '&.Mui-checked': {
                                                color: colors.dashbordGreen[500],
                                            },
                                        }} />}
                                        color="success"
                                        label={formatMessage(messages.thisWeek)}//"This week"
                                    />
                                    <FormControlLabel
                                        value="currentShift"
                                        control={<Radio {...controlProps("month")} sx={{
                                            color: "secondary",
                                            '&.Mui-checked': {
                                                color: colors.dashbordGreen[500],
                                            },
                                        }} />}
                                        color="success"
                                        label={formatMessage(messages.thisMonth)}//"This month"
                                    />
                                    <FormControlLabel
                                        value="currentShift"
                                        control={<Radio {...controlProps("ThreeMonths")} sx={{
                                            color: "secondary",
                                            '&.Mui-checked': {
                                                color: colors.dashbordGreen[500],
                                            },
                                        }} />}
                                        color="success"
                                        label={formatMessage(messages.threeMonths)}//"Three months"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Stack>
                    {/* </Grid> */}
                    {/* <Grid item xs={12} lg={8}>
                        <Stack direction="row" width="100%" marginLeft={2} spacing={2}>
                            <DateFilter onDataReceived={handleTimeSpan} startDate={startDate} endDate={endDate} hideManual={true} showWeek={true} />
                        </Stack>
                    </Grid> */}
                    {/* </Grid> */}
                </Stack>
            </Box>

                    <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                        {showList &&
                            <ProductionPlanMachineList
                                plannedData={unfilteredData}
                                setPlannedData={setPlannedData}
                                handleOpenUpdatePO={handleOpenUpdatePO}
                                handleOpenNewPO={handleOpenNewPO}
                                OeeDataQuery={OeeDataQuery}
                                handleClickRow={handleClickRow}
                                machineData={machineQuery.data}
                            />
                        }
                        {!showList &&

                            <Gantt
                                data={plannedData}
                                handleClick={handleClick}
                                startDate={startDatex}
                                endDate={endDatex}
                                company={companyQuery?.data}
                                featureFlags={featuresQuery?.data}
                                featuresQuery={featuresQuery}
                                handleUpdateData={handleUpdateData}
                                timeSpan={timeSpan}
                                redrawChart={openPopup}
                                runningFilter={runningFilter}
                                calculatedEndFilter={calculatedEndFilter}
                                showReplanned={showReplanned}
                                showMain={showMain}
                                showCalendar={showCalendar}
                                handleRunningFilter={handleRunningFilter}
                                handleCalculatedEndFilter={handleCalculatedEndFilter}
                                handleShowReplanned={handleShowReplanned}
                                handleShowMain={handleShowMain}
                                handleShowCalendar={handleShowCalendar}
                                handleOpenNewPO={handleOpenNewPO}
                                handleOpenUpdatePO={handleOpenUpdatePO}
                                snapToPrevious={snapToPrevious}
                                replanOverlaps={replanOverlaps}
                                edit={edit}
                                recalculateAffectedOrders={recalculateAffectedOrders}
                                setSnapToPrevious={setSnapToPrevious}
                                setReplanOverlaps={setReplanOverlaps}
                                setRecalculateAffectedOrders={setRecalculateAffectedOrders}
                                setEdit={handleSetEdit}
                                handleCancelSaveAll={handleCancelSaveAll}
                                handleSaveAll={handleSaveAll}
                                disableSaveButton={disableSaveButton}
                                setDisableSaveButton={setDisableSaveButton}
                                handleSaveMarkedRows={handleSaveMarkedRows}
                                handleCheckboxClick={handleCheckboxClick}
                                markedForUpdate={markedForUpdate}
                                handleRowUndoClick={handleRowUndoClick}
                                zoomLevel={zoomLevel}
                                setZoomLevel={setZoomLevel}
                                zoomToDates={zoomToDates}
                                showReplannedLocal={showReplannedLocal}
                                defaultOee={defaultOee}
                                showBlockValue={showBlockValue}
                                handleSetShowBlockValue={handleSetShowBlockValue}
                                handleRowSaveClick={handleRowSaveClick}
                                handleShowUnsaved={handleShowUnsaved}
                                showUnsaved={showUnsaved}
                            />
                        }
                    </Box>
         

        </Box>
        <Popup
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
            //maxWidth="sm"
            // title={<FormattedMessage {...messages.editStop} />}>
            title={formatMessage(messages.details) + period?.productionOrderId + " -- " + formatMessage(messages.article) + period?.itemName}
        >
            <ProductionPlanInfoDialog
                operation={period}
                oeeData={OeeDataQuery.data}
                handleOpenUpdatePO={handleOpenUpdatePO}
                edit={edit}
            />
        </Popup>

        <Popup
            width="300px"
            height="800px"
            openPopup={openAddPopup}
            setOpenPopup={setOpenAddPopup}
            maxWidth="sm"
            title={formatMessage(messages.newPplLabelHeadline)}
        >
            <PlanNewPODialog
                machineData={plannedData[0]?.children?.filter(machine => machine.id === editMachine?.la?.id)}
                operation={period}
                oeeData={OeeDataQuery.data}
                machineQuery={machineQuery.data}
                machine={editMachine}
                setOpenAddPopup={setOpenAddPopup}
                addObjAtTime={addObjAtTime}
                snapToPrevious={snapToPrevious}
                replanOverlaps={replanOverlaps}
                recalculateAffectedOrders={recalculateAffectedOrders}
                setSnapToPrevious={setSnapToPrevious}
                setReplanOverlaps={setReplanOverlaps}
                setRecalculateAffectedOrders={setRecalculateAffectedOrders}
                edit={edit}
                handleRefreshData={handleRefreshData}
                setShowBackdrop={setShowBackdrop}
                showBackdrop={showBackdrop}
                companyKey={companyKey}
                plannedData={plannedData}
                scheduleRows={scheduleRowsQuery.data}
                historicOeeData={historicOeeDataQuery.data}
            // blockTextBefore={blockTextBefore}
            // setBlockTextBefore={setBlockTextBefore}
            // minutesBefore={minutesBefore}
            // setMinutesBefore={setMinutesBefore}
            // addBlockBefore={addBlockBefore}
            // setAddBlockBefore={setAddBlockBefore}

            // blockTextAfter={blockTextAfter}
            // setBlockTextAfter={setBlockTextAfter}
            // minutesAfter={minutesAfter}
            // setMinutesAfter={setMinutesAfter}
            // addBlockAfter={addBlockAfter}
            // setAddBlockAfter={setAddBlockAfter}
            />
        </Popup>

        <Popup
            width="300px"
            openPopup={openUpdatePopup}
            setOpenPopup={setOpenUpdatePopup}
            maxWidth="sm"
            // title={<FormattedMessage {...messages.editStop} />}>
            title={"Update a planned production order"}
        >
            <PlanUpdatePODialog
                //machineData={plannedData[0]?.children?.filter(machine => machine.id === period?.machineId)}
                plannedData={plannedData}
                operation={period}
                oeeData={OeeDataQuery.data}
                machineQuery={machineQuery.data}
                machine={editMachine}
                snapToPrevious={snapToPrevious}
                replanOverlaps={replanOverlaps}
                recalculateAffectedOrders={recalculateAffectedOrders}
                setSnapToPrevious={setSnapToPrevious}
                setReplanOverlaps={setReplanOverlaps}
                setRecalculateAffectedOrders={setRecalculateAffectedOrders}
                edit={edit}
                handleRefreshData={handleRefreshData}
                setShowBackdrop={setShowBackdrop}
                setOpenUpdatePopup={setOpenUpdatePopup}
                scheduleRows={scheduleRowsQuery.data}
                historicOeeData={historicOeeDataQuery.data}
            />
        </Popup>

        <AxionControls.AxionBackdrop open={showBackdrop} />
    </>
}